import { Box, Typography } from "@mui/material";

import { PopupActions } from "@store/popupStore";

/**
 * Open a popup displaying text.
 * @param title - Popup title.
 * @param displayText - Text to display in the popup.
 */
const openTextRowPopup = (title: string, displayText: string) => {
  PopupActions.openModal({
    content: (
      <Box sx={{ maxHeight: "400px", overflow: "auto", p: 2 }}>
        <Typography>{displayText}</Typography>
      </Box>
    ),
    title,
  });
};

export default openTextRowPopup;
